import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class H5pService {
	public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor() {}

	public loading(isLoading: boolean): void {
		this.loading$.next(isLoading);
	}
}
